"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBulkAction = exports.StyledBulkActionsContainer = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledBulkActionsContainer = styled_components_1.default.div `
  display: grid;
  grid-template-columns: 1fr repeat(2, auto);
  grid-auto-columns: auto;
  grid-auto-flow: column;
  column-gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  background-color: ${ui_components_1.baseColors.primaryGreen001};
  padding: ${({ theme }) => theme.spacing(1, 2)};
`;
exports.StyledBulkAction = (0, styled_components_1.default)(ui_components_1.Button) `
  font-size: 0.875rem;
`;
